import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IError } from '../core/interfaces/error.interface';
import { TranslationService } from './translation.service';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private messages = [
    'API_ERRORS.FORBIDDEN_ERROR',
    'API_ERRORS.EMAIL_NOT_FOUND',
    'API_ERRORS.INVALID_CREDENTIALS',
    'API_ERRORS.INVALID_EMAIL',
    'API_ERRORS.INVALID_PASSWORD',
    'API_ERRORS.EMAIL_EXISTS',
    'API_ERRORS.EMAIL_IS_DISABLED',
    'INVALID_EMAIL',
    'INVALID_PASSWORD',
    'EMAIL_EXISTS',
    'EMAIL_NOT_FOUND',
    'INVALID_CREDENTIALS',
    'RETIRED_BUILDING_CANNOT_DELETE',
    'API_ERRORS.OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.FOREIGN_KEY_CONSTRAIN_ERROR',
    'API_ERRORS.BUILDING_NOT_FOUND',
    'API_ERRORS.BUILDING_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.PROPS_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.ADDRS_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.RIGHTS_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.DOC_RIGHT_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.ΒΕΝ_RIGHT_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.ΒΕΝ_NOT_FOUND',
    'API_ERRORS.BUILDING_PROP_NOT_FOUND',
    'API_ERRORS.PARCEL_PROP_NOT_FOUND',
    'API_ERRORS.PARCEL_NOT_FOUND',
    'API_ERRORS.PARCEL_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.ADDR_NOT_FOUND',
    'API_ERRORS.RIGHTS_NOT_FOUND',
    'API_ERRORS.FILETYPE_NOT_SUPPORTED',
    'API_ERRORS.SAME_FILENAME_FOUND',
    'API_ERRORS.DOC_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.ISSUERHQ_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.ISSUER_NOT_FOUND',
    'API_ERRORS.PROP_EIDOS_NOT_FOUND',
    'API_ERRORS.PROP_EIDOS_OPTIMISTIC_LOCK_ERROR',
    'REPORTS.API_ERRORS.REPORT_NOT_FOUND',
    'API_ERRORS.DOC_NOT_FOUND',
    'REPORTS.API_ERRORS.REPORT_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.REPORT_FOREIGN_KEY_CONSTRAIN_ERROR',
    'REPORTS.API_ERRORS.REPORT_FOREIGN_KEY_CONSTRAIN_ERROR',
    'API_ERRORS.ROLE_NOT_FOUND',
    'API_ERRORS.ROLE_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.ROLE_FOREIGN_KEY_CONSTRAIN_ERROR',
    'API_ERRORS.BUILD_PERMITS_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.BUILD_PERMITS_NOT_FOUND',
    'API_ERRORS.PROP_PHOTOS_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.PROP_TAX_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.PROP_TAX_NOT_FOUND',
    'API_ERRORS.PROP_MONTHLY_COSTS_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.PROP_MONTHLY_COSTS_NOT_FOUND',
    'API_ERRORS.PROP_UTILITIES_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.PROP_UTILITIES_NOT_FOUND',
    'API_ERRORS.DOMAIN_NOT_FOUND',
    'API_ERRORS.USER_NOT_FOUND',
    'API_ERRORS.USER_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.USER_FOREIGN_KEY_CONSTRAIN_ERROR',
    'API_ERRORS.BUILD_PERMIT_FILES_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.FLOOR_FILES_OPTIMISTIC_LOCK_ERROR',
    'API_ERRORS.RETIRED_BUILDING_CANNOT_UPDATE'
  ];

  constructor(private translationService: TranslationService) { }

  mapError = (error: unknown): IError => {
    let errorMessage = (error as HttpErrorResponse).status === 0 ? this.translationService.translate(
      'COMMON.ERRORS.SERVER_NO_RESPOND'
    ) : `${this.translationService.translate(
      'COMMON.ERRORS.SERVER_NO_RESPOND'
    )} (${(error as HttpErrorResponse).status})`;

    switch (true) {
      case error instanceof HttpErrorResponse: {
        const httpErrorInstanse = error as HttpErrorResponse;
        if (httpErrorInstanse.status === 0) {
          if (httpErrorInstanse.message.includes('Http failure response')) {
            return {
              name: httpErrorInstanse.name,
              message: httpErrorInstanse.message,
              messageToUser: errorMessage = (error as HttpErrorResponse).status === 0 ? this.translationService.translate(
                'COMMON.ERRORS.SERVER_NO_RESPOND'
              ) : `${this.translationService.translate(
                'COMMON.ERRORS.SERVER_NO_RESPOND'
              )} (${(error as HttpErrorResponse).status})`,
              stack: null,
            };
          }
          return {
            name: httpErrorInstanse.name,
            message: httpErrorInstanse.message,
            messageToUser: httpErrorInstanse.message,
            stack: null,
          };
        }
        const errorInstanseError = httpErrorInstanse.error as Error;

        if (this.messages.includes(errorInstanseError.message)) {
          errorMessage = this.translationService.translate(
            errorInstanseError.message,
            errorInstanseError['data']
          );
        }
        return {
          name: errorInstanseError.name || null,
          message: errorInstanseError.message,
          messageToUser: errorMessage,
          stack: errorInstanseError.stack,
        };
      }
      case error instanceof Error: {
        const errorInstanse = error as Error;

        if (this.messages.includes(errorInstanse.message)) {
          errorMessage = this.translationService.translate(
            errorInstanse.message
          );
        }
        return {
          name: `${errorInstanse.name} (${errorInstanse.name})`,
          message: errorInstanse.message,
          messageToUser: errorMessage,
          stack: errorInstanse.stack,
        };
      }
    }
  };
}
